export default __webpack_public_path__ + "static/media/SEDnew.a1142c6b.png";